<template>
    <v-app class="homepage homepage-b2b api-soft-promo">
        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__main promo-layout">
                <div class="api-soft-promo__title">
                    <h2>getpolis</h2>
                </div>
                <div class="api-soft-promo__subtitle">
                    <p class="green-soft">Soft</p>
                    <p>Твой агрегатор. Твои правила.<br>Без миллионных вложений.</p>
                </div>
                <div class="api-soft-promo__regalia">
                    <div class="api-soft-promo__regalia__item" v-for="(item, index) in regaliaArray" :key="index">
                        <img :src="item.img" :alt="'logo-' + index">
                        <p v-html="item.text"></p>
                    </div>
                </div>
                <v-flex class="api-soft-promo__buttons">
                    <v-btn
                        class="button green-button"
                        @click="openBitrixDialog"
                    >
                        Подключиться<br>уже сейчас
                    </v-btn>
                    <v-btn
                        class="button white-button"
                        @click="goToDescription"
                    >
                        Подробнее<br>о продукте
                    </v-btn>
                </v-flex>
            </div>
            <v-container class="second-block">
                <v-layout class="b2b-slider">
                    <v-carousel
                        hide-delimiters
                    >
                        <v-carousel-item
                            v-for="(item,i) in items"
                            :key="i"
                            :interval="3000"
                            :src="item.src"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </v-layout>
                <div class="flex b2b-green-circle"></div>
            </v-container>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__what-is promo-layout" id="description">
                <div class="api-soft-promo__what-is__title">
                    <h3>Что такое getpolis <span>Soft</span></h3>
                </div>
                <div class="api-soft-promo__what-is__subtitle">
                    <p>Это все ваши прямые договоры и комиссии по ОСАГО + десятки других СК <br>в одном окне. Работайте быстрее, зарабатывайте больше.</p>
                </div>
                <div class="api-soft-promo__what-is__plan">
                    <div class="grey-block">
                        <div class="grey-block__insurers border-block">
                            <p>Страховые компании</p>
                            <div class="insurers-bags">
                                <img src="/img/api-soft/bag.svg" alt="bag-1">
                                <img src="/img/api-soft/bag.svg" alt="bag-2">
                                <img src="/img/api-soft/bag.svg" alt="bag-3">
                                <img src="/img/api-soft/bag.svg" alt="bag-4">
                            </div>
                        </div>
                        <div class="grey-block__aggregation border-block">
                            <p>Агрегация предложений<br>в едином кабинете</p>
                            <div class="aggregation-picks">
                                <img src="/img/api-soft/aggregation-1.svg" alt="aggregation-1">
                                <img src="/img/api-soft/aggregation-2.svg" alt="aggregation-2">
                            </div>
                        </div>
                        <div class="grey-block__crm border-block">
                            <div class="crm-picks">
                                <img src="/img/api-soft/crm-1.svg" alt="crm-1">
                                <img src="/img/api-soft/crm-2.svg" alt="crm-2">
                            </div>
                            <p>Внутренняя CRM<br>и контроль продаж</p>
                        </div>
                    </div>
                    <div class="green-block">
                        <h4>Как происходит <br class="green-block__h4-text-1200">подключение</h4>
                        <div class="green-block__step">
                            <div class="green-block__circle"><span>01</span></div>
                            <div class="green-block__content">
                                <p class="step-title">Заключение договора</p>
                                <p class="step-text"><b>Вы</b> отправляете нам свои реквизиты.</p>
                                <p class="step-text"><b>Мы</b> делаем лицензионный договор.</p>
                            </div>
                        </div>
                        <div class="green-block__step">
                            <div class="green-block__circle"><span>02</span></div>
                            <div class="green-block__content">
                                <p class="step-title">Техническое подключение</p>
                                <p class="step-text"><b>Вы</b> передаёте нам API-ключи (запрашиваются у Ваших кураторов <br>в Страховых Компаниях).</p>
                                <p class="step-text"><b>Мы</b> подключаем Страховые Компании.</p>
                            </div>
                        </div>
                        <div class="green-block__step">
                            <div class="green-block__circle"><span>03</span></div>
                            <div class="green-block__content">
                                <p class="step-title">Активация доступа</p>
                                <p class="step-text"><b>Вы</b> оплачиваете наш счёт.</p>
                                <p class="step-text"><b>Мы</b> активируем Ваш доступ.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="api-soft-promo__what-is__footer">
                    <p><span>Назначение платформы:</span></p>
                    <p>Обеспечить быстрый, процессно - и юридически корректный, безопасный обмен данными между всеми страховыми компаниями в портфеле агента.</p>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__advantages promo-layout">
                <div class="api-soft-promo__advantages__title">
                    <h3>Преимущества getpolis <span>Soft</span></h3>
                </div>
                <div class="api-soft-promo__advantages__blocks">
                    <div class="block black">
                        <div class="block__text">
                            <h4>Экономия времени</h4>
                            <p>В нашем В2B один расчёт по 20 СК занимает до 2 мин., а расчёт в кабинете только одной
                                СК от 5 мин. Данные подтверждены хронометражем и отзывами пользователей.</p>
                            <p>Ваша выгода: Вы тратите 2 минуты вместо 100 на подбор оптимального предложения для клиента.</p>
                        </div>
                        <div class="block__text">
                            <h4>Автоматизация работы с пролонгацией</h4>
                            <p>Встроенный инструмент для пролонгации работает как мини-CRM: напоминания, комментарии,
                                переносы дат. Если СК изменила условия, то Вы мгновенно подберете новое предложение из
                                15+ компаний без переноса данных вручную.</p>
                            <p>Ваша выгода: Ни один клиент не будет потерян и не останется без лучшего предложения.</p>
                        </div>
                    </div>
                    <div class="block green">
                        <div class="block__text">
                            <h4>Единый доступ ко всем<br>договорам</h4>
                            <p>Все ваши прямые договоры со СК плюс доступ к 15+ нашим партнерским компаниям в одном
                                личном кабинете с любого устройства.</p>
                            <p>Ваша выгода: Вы на 100% закрываете потребность клиента, гарантированно предлагая ему
                                лучшее предложение на рынке.</p>
                        </div>
                        <div class="block__text">
                            <h4>Сохранение вашей<br>комиссии</h4>
                            <p>Все вознаграждения по вашим агентским договорам поступают напрямую от страховых
                                компаний на ваш счет. Условия и размер комиссии остаются неизменными.</p>
                            <p>Ваша выгода: Вы ничего не теряете в деньгах и условиях, только приобретаете новые
                                инструменты для роста.</p>
                        </div>
                    </div>
                    <div class="block grey">
                        <div class="block__text">
                            <h4>Мобильный офис<br>в вашем телефоне</h4>
                            <p>Полнофункциональный кабинет, который всегда под рукой. Оформляйте и продавайте
                                из любой точки мира.</p>
                            <p>Ваша выгода: Вы всегда на связи и можете оформить полис клиенту за 2 минуты,
                                даже не находясь в офисе.</p>
                        </div>
                        <img src="/img/api-soft/iphone.png" alt="iphone">
                    </div>
                </div>
                <div class="api-soft-promo__advantages__button">
                    <v-btn
                        class="button green-button"
                        @click="openBitrixDialog"
                    >
                        Подключиться и начать продавать больше.
                    </v-btn>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__partners promo-layout">
                <div class="api-soft-promo__partners__title-layout">
                    <div class="api-soft-promo__advantages__title api-soft-promo__partners__title">
                        <h3>getpolis <span>Soft</span> — свобода выбора: подключим всех, кто нужен твоему бизнесу</h3>
                    </div>
                </div>
                <div class="api-soft-promo__partners__subtitle">
                    <p>Ведущие страховые компании — готовы к твоему подключению.</p>
                </div>
                <div class="api-soft-promo__partners__list">
                    <div class="partner-item" v-for="(partner, index) in partnersList" :key="index">
                        <img :src="partner.img" alt="logo">
                    </div>
                </div>
                <div class="api-soft-promo__partners__footer">
                    <p>Гибкость: API-ключи можно подключать по мере заключения Ваших новых агентских договоров</p>
                    <p><span>20+ партнерских компаний всегда</span><br>доступны в едином расчете</p>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__investment promo-layout">
                <div class="api-soft-promo__advantages__title api-soft-promo__investment__title">
                    <h3>Инвестиция, которая окупается уже на старте</h3>
                </div>
                <div class="api-soft-promo__investment__main-block">
                    <div class="green-block">
                        <div class="green-block__chapters-layout">
                            <div class="green-block__chapter">
                                <h4>Тариф на подключение к платформе</h4>
                                <p>Оптимальное подключение к страховым и финансовым сервисам — всё включено, ничего лишнего.</p>
                            </div>
                            <div class="green-block__chapter">
                                <h4>Специальное предложение до {{ promoEndDateFormatted }} года</h4>
                                <p>Воспользуйтесь акционным тарифом всего за 3 000 рублей в месяц вместо стандартных 10 000 рублей.</p>
                                <p>Это выгодное предложение действует на одного пользователя.</p>
                            </div>
                            <div class="green-block__chapter">
                                <h4>Важные условия спецпредложения:</h4>
                                <p>Акционная цена фиксируется на полные 12 месяцев с момента первой оплаты</p>
                                <p>Даже если вы подключитесь в последний день акции, льготная стоимость сохранится на весь год</p>
                                <p>Экономия составляет 84 000 рублей за год использования</p>
                                <p>Начните с минимального пакета и масштабируйте по мере роста вашего бизнеса!</p>
                            </div>
                        </div>
                    </div>
                    <div class="black-block">
                        <div class="black-block__chapters-layout">
                            <div class="black-block__chapter">
                                <p class="price-old">10 000 ₽/месяц.</p>
                                <p class="price">3 000 ₽/месяц</p>
                                <p class="monthly">ежемесячно</p>
                                <p class="hint">Включено до 5 страховых <br>компаний в кабинете</p>
                            </div>
                            <div class="black-block__chapter">
                                <p class="price">1 000 ₽/месяц</p>
                                <p class="monthly">ежемесячно</p>
                                <p class="hint">Каждая последующая <br>компания в интеграции</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__reviews promo-layout">
                <div class="api-soft-promo__reviews__header">
                    <div class="api-soft-promo__advantages__title api-soft-promo__reviews__title">
                        <h3>Что говорят те, кто уже работает с getpolis <span>Soft</span></h3>
                    </div>
                    <div class="api-soft-promo__reviews__header__buttons">
                        <div class="button-left" :class="{ disabled: !canScrollLeft }" @click="scrollLeft">
                            <img
                                :src="canScrollLeft ? '/img/home/arrow-right.svg' : '/img/home/arrow2-right-grey.svg'"
                                style="transform: rotate(180deg)"
                                alt="left"
                            >
                        </div>
                        <div class="button-right" :class="{ disabled: !canScrollRight }" @click="scrollRight">
                            <img :src="canScrollRight ? '/img/home/arrow-right.svg' : '/img/home/arrow2-right-grey.svg'" alt="right">
                        </div>
                    </div>
                </div>

                <div class="homepage__container-reviews__main" ref="reviewsContainer">
                    <div class="review-block" v-for="(item, index) in reviewsArray" :key="index">
                        <div class="review-block__top">
                            <div class="review-block__top__agent">
                                <p class="name">{{ item.name }}</p>
                                <p class="city">{{ item.city }}</p>
                            </div>
                            <div class="review-block__top__text">
                                <p class="text">{{ item.text }}</p>
                            </div>
                        </div>
                        <div class="review-block__bottom">
                            <div class="review-block__bottom__stars">
                                <div class="star" v-for="(star, index) in item.stars" :key="index">
                                    <img src="/img/home/star.svg" alt="star">
                                </div>
                            </div>
                            <div class="review-block__bottom__date">
                                <p class="date">дата</p>
                                <p>{{ item.date }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white">
            <div class="api-soft-promo__why-you-should promo-layout">
                <div class="api-soft-promo__advantages__title api-soft-promo__why-you-should__title">
                    <h3>Почему подключиться к getpolis <span>Soft</span> стоит уже сегодня?</h3>
                </div>
                <div class="api-soft-promo__why-you-should__main-blocks">
                    <div class="block" v-for="(item, index) in whyYouShouldArray" :key="index" :class="item.color">
                        <div class="block__wrapper">
                            <h4>{{ item.title }}</h4>
                            <p v-html="item.text"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__container api-soft-promo__white api-soft-promo__last-container">
            <div class="api-soft-promo__faq homepage__container-faq promo-layout">
                <div class="api-soft-promo__advantages__title api-soft-promo__faq__title">
                    <h3>Частые вопросы</h3>
                </div>
                <home-questions
                    :faq="faq"
                />
                <v-flex wrap row class="homepage__container-faq__any-question api-soft-promo__faq__any-question">
                    <h3>Остались вопросы?</h3>
                    <v-flex class="homepage__container-faq__any-question__text">
                        <p>По любым вопросам пишите на <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, или звоните 8 800 350 72 61.<br>Расскажем, проконсультируем.</p>
                        <a class="black-button" @click="openFeedback">Задать вопрос</a>
                    </v-flex>
                </v-flex>
                <div class="api-soft-promo__faq__button">
                    <v-btn
                        class="button green-button"
                        @click="openBitrixDialog"
                    >
                        Стать партнёром Getpolis
                    </v-btn>
                </div>
            </div>
        </div>

        <div class="api-soft-promo__footer-container api-soft-promo__white">
            <div class="api-soft-promo__footer">
                <div class="api-soft-promo__footer__copyright">
                    <p>ООО Гетполис © 2021</p>
                </div>
                <a href="">О продукте</a>
                <a href="/osago_faq">Вопросы</a>
                <a href="/osago_policy" class="api-soft-promo__footer__osago-policy">Политика обработки <br class="api-soft-promo__footer__br">персональных данных</a>
                <a href="/osago_user_agreement" class="api-soft-promo__footer__osago-user-agreement">Пользовательское <br class="api-soft-promo__footer__br">соглашение</a>
                <a href="/news">Новости</a>
                <a href="/blog">Блог</a>
                <a href="/osago_faq">FAQ</a>
                <a href="/osago_contacts">Контакты</a>
            </div>
        </div>

        <homepage-feedback
            :dialog="dialog"
            @closeFeedback="closeFeedback"
        />

        <bitrix-form
            :dialog="bitrixDialog"
            @closeBitrixDialog="closeBitrixDialog"
        />
    </v-app>
</template>

<script>
export default {
    data: () => ({
        bitrixDialog: false,
        dialog: false,
        canScrollLeft: false,
        canScrollRight: true,
        items: [
            {
                src: '/img/b2b_slider/macbook.png',
            },
            {
                src: '/img/b2b_slider/ipad.png',
            },
            {
                src: '/img/b2b_slider/iphone.png',
            },
        ],
        regaliaArray: [
            {
                text: `Аккредитованная IT-компания<br>Запись № АО-20230726-13560604465-3 от 01.08.2023`,
                img: '/img/api-soft/logo-1.png',
            },
            {
                text: `Зарегистрировано в качестве программы для ЭВМ<br>Запись №2022617332 от 19.04.2022`,
                img: '/img/api-soft/logo-2.png',
            },
            {
                text: `Резидент инновационного центра Сколково<br>Рег.№ 1127664`,
                img: '/img/api-soft/logo-3.png',
            },
            {
                text: `Внесено в реестр отечественного ПО<br>Запись №22456 от 14.05.2024`,
                img: '/img/api-soft/logo-4.png',
            },
        ],
        partnersList: [
            {
                img: '/img/partners/absolute.svg',
            },
            {
                img: '/img/alfa.svg',
            },
            {
                img: '/img/partners/astro-volga.svg',
            },
            {
                img: '/img/borovitskoe.svg',
            },
            {
                img: '/img/vsk-color.svg',
            },
            {
                img: '/img/gelios-new-color.svg',
            },
            {
                img: '/img/zetta-color.svg',
            },
            {
                img: '/img/ingosstrah.svg',
            },
            {
                img: '/img/maks.svg',
            },
            {
                img: '/img/pari-color.svg',
            },
            {
                img: '/img/renessans-color.svg',
            },
            {
                img: '/img/rosgosstrah.svg',
            },
            {
                img: '/img/sber-color.svg',
            },
            {
                img: '/img/sovkombank-color.svg',
            },
            {
                img: '/img/sogaz-color.svg',
            },
            {
                img: '/img/soglasie.svg',
            },
            {
                img: '/img/tink-color.svg',
            },
            {
                img: '/img/partners/energo_garant.svg',
            },
            {
                img: '/img/yugoria.svg',
            },
            {
                img: '/img/sk21vek.svg',
            },
        ],
        reviewsArray: [
            {
                name: 'Денис Клюев, 36 лет',
                city: 'Нижний Новгород',
                text: 'Честно, я не ожидал, что расчёты по 15 страховым будут занимать пару минут. Getpolis SOFT просто разгрузил мне голову — теперь успеваю брать больше заявок, чем раньше за целый день',
                stars: 5,
                date: '28.05.2024',
            },
            {
                name: 'Светлана Даниленко, 44 года',
                city: 'Ростов-на-Дону',
                text: 'Я наконец перестала путаться в договорах и кабинетах. Всё в одном месте, всё понятно. Клиенты удивляются, как быстро я им теперь подбираю варианты.',
                stars: 5,
                date: '29.05.2024',
            },
            {
                name: 'Кирилл Попов, 39 лет',
                city: 'Ростов',
                text: '«Самое приятное — перестал терять комиссии. Всё чисто, прозрачно, без сюрпризов. Доход растёт стабильно, и это впервые за долгое время.»',
                stars: 5,
                date: '30.05.2024',
            },
            {
                name: 'Анна Новикова, 34 года',
                city: 'Краснодар',
                text: '«Работаю часто в разъездах, поэтому мобильная версия для меня спасение. Оформила полис прямо в кафе — клиент доволен, я тоже.»',
                stars: 5,
                date: '30.05.2024',
            },
            {
                name: 'Александр Колода, 38 лет',
                city: 'Красноярск',
                text: '«Я вечно забывал про пролонгации. Автоматические напоминания спасли. Теперь ни один клиент не уходит, и повторные продажи реально выросли.»',
                stars: 5,
                date: '30.05.2024',
            },
            {
                name: 'Владимир Моржов, 40 лет',
                city: 'Новосибирск',
                text: '«Подключил дополнительные страховые компании под себя — потребовалось пару часов. Бизнес стал гибче, а предложений клиентам стало намного больше.»',
                stars: 5,
                date: '30.05.2024',
            },
            {
                name: 'Кирилл Кармозин, 32 года',
                city: 'Сочи',
                text: '«Сервис убрал всю рутину. Не перескакиваю между двадцатью вкладками, не ловлю ошибки. Сижу спокойно, считаю, оформляю — стало работать гораздо легче.»',
                stars: 5,
                date: '30.05.2024',
            },
        ],
        whyYouShouldArray: [
            {
                title: 'Окупаемость с первых продаж',
                text: 'Уже при 5 проданных ОСАГО подписка полностью покрывает себя и дальше приносит, и увеличивает чистую прибыль.',
                color: 'green',
            },
            {
                title: 'Рост продаж',
                text: 'Благодаря экономии времени и доступу к 20+ СК наши пользователи в среднем продают на 16 полисов ОСАГО в месяц больше (по результатам опроса 274 агентов).',
                color: 'grey',
            },
            {
                title: 'Максимальное удержание клиентов',
                text: 'Если одна СК не одобрила заявку, вы сразу подбираете альтернативное решение в том же расчете.',
                color: 'black',
            },
            {
                title: 'Гибкость',
                text: `API-ключи можно подключать по мере заключения<br>Ваших новых агентских договоров.`,
                color: 'green',
            }
        ],
        faq: [
            {
                question: 'Можно ли работать в Getpolis Soft без прямых договоров со страховыми компаниями?',
                answer: 'Да. Платформа предоставляет доступ к страховым компаниям через инфраструктуру Getpolis. ' +
                    'Если у агента есть свои прямые договоры — их можно подключить дополнительно, но это не ' +
                    'обязательное условие для старта.'
            },
            {
                question: 'Какие страховые продукты доступны внутри платформы и как часто обновляются котировки?',
                answer: 'В системе доступны основные массовые продукты: ОСАГО, КАСКО, ВЗР, имущество, НС, ' +
                    'медицина и другие позиции, представленные партнёрскими компаниями. Котировки обновляются ' +
                    'автоматически по мере изменений у страховых — агент всегда работает с актуальными тарифами.'
            },
            {
                question: 'Как работает автоматическое заполнение данных страхователя и где оно поддерживается?',
                answer: 'Платформа подтягивает и заполняет данные страхователя в личных кабинетах страховых ' +
                    'компаний и маркетплейсов, снижая ручную рутину. Механика работает в большинстве ' +
                    'интегрированных кабинетов и постоянно расширяется.'
            },
            {
                question: 'Что делать, если клиент оформляет полис повторно? Работают ли напоминания о пролонгациях?',
                answer: 'Система автоматически фиксирует сроки действия полисов и отправляет напоминания о ' +
                    'пролонгации. Агент получает уведомления заранее, чтобы не терять повторные продажи и ' +
                    'удерживать клиента в своей базе.'
            },
            {
                question: 'Можно ли подключить дополнительные страховые компании под себя и сколько это занимает времени?',
                answer: 'Да, агент может подключить дополнительные компании — процесс занимает от одного до ' +
                    'нескольких часов в зависимости от партнёра. Вся процедура проходит внутри платформы ' +
                    'без лишней бюрократии.'
            },
            {
                question: 'Как считается комиссия агента и где её можно контролировать, чтобы не было потерь?',
                answer: 'Комиссия отображается в личном кабинете в режиме реального времени. Вся история выплат, ' +
                    'проверка статусов и детализация по заказам доступны в прозрачном формате, что устраняет ' +
                    'риск потерь и некорректных начислений.'
            },
            {
                question: 'Работает ли Getpolis Soft в мобильной версии и можно ли оформлять полисы «в разъездах»?',
                answer: 'Да, мобильная версия полностью адаптирована под оперативную работу. Агент может ' +
                    'рассчитывать, оформлять и отправлять документы прямо с телефона — в кафе, в дороге или на ' +
                    'встрече с клиентом.'
            },
        ],
    }),
    computed: {
        /**
         * Дата окончания спецпредложения в формате ДД.ММММ.ГГГГ.
         * Показывает последний день текущего месяца; в последний день месяца — последний день следующего месяца.
         * Учитывает разную длину месяцев и високосные годы.
         */
        promoEndDateFormatted() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth();

            const lastDayOfCurrentMonth = new Date(year, month + 1, 0);
            const isTodayLastDayOfMonth = now.getDate() === lastDayOfCurrentMonth.getDate();

            const targetDate = isTodayLastDayOfMonth
                ? new Date(year, month + 2, 0)
                : lastDayOfCurrentMonth;

            const day = String(targetDate.getDate()).padStart(2, '0');
            const monthsGenitive = [
                'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
            ];
            const monthName = monthsGenitive[targetDate.getMonth()];
            const yearNum = targetDate.getFullYear();

            return `${day} ${monthName} ${yearNum}`;
        },
    },
    methods: {
        openBitrixDialog() {
            this.bitrixDialog = true
        },
        closeBitrixDialog() {
            this.bitrixDialog = false
        },
        openFeedback() {
            this.dialog = true
        },
        closeFeedback() {
            this.dialog = false
        },
        scrollLeft() {
            if (!this.canScrollLeft) {
                return;
            }
            const container = this.$refs.reviewsContainer;
            const blockWidth = container.children[0].offsetWidth + 16;

            container.scrollLeft -= blockWidth;
            this.updateArrows();
        },

        scrollRight() {
            if (!this.canScrollRight) {
                return;
            }
            const container = this.$refs.reviewsContainer;
            const blockWidth = container.children[0].offsetWidth + 16;

            container.scrollLeft += blockWidth;
            this.$nextTick(() => {
                this.updateArrows();
            })
        },

        updateArrows() {
            const container = this.$refs.reviewsContainer;

            this.$nextTick(() => {
                // Если scrollLeft > 0 → можно листать влево
                this.canScrollLeft = container.scrollLeft > 0;

                // Если справа есть ещё место → можно листать вправо
                this.canScrollRight =
                    container.scrollLeft + container.offsetWidth < container.scrollWidth;
            })
        },

        goToDescription() {
            this.$vuetify.goTo('#description', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/ApiSoftPromo.vue